/* src/app/shared/ui-kit/pa-file-list/pa-file-list.component.scss */
.pa-file-list {
  display: inline-block;
  position: relative;
}
::ng-deep .pa-file-list-menu {
  min-width: 280px;
  max-width: 400px;
}
::ng-deep .pa-file-list-menu .p-menu-list {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
::ng-deep .pa-file-list-menu .p-menuitem .p-menuitem-content {
  padding: 0 !important;
}
::ng-deep .pa-file-list-menu .p-menuitem .p-menuitem-link {
  padding: 0 !important;
  border-radius: 0 !important;
}
::ng-deep .pa-file-list-menu .file-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  width: 100%;
  min-height: 56px;
}
::ng-deep .pa-file-list-menu .file-item .file-icon-wrapper {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
}
::ng-deep .pa-file-list-menu .file-item .file-image {
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--secondary-subtle-default);
}
::ng-deep .pa-file-list-menu .file-item .file-image img {
  width: 100%;
  height: 100%;
  min-width: 40px;
  min-height: 40px;
  object-fit: cover;
  display: block;
}
::ng-deep .pa-file-list-menu .file-item .file-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: var(--secondary-subtle-default);
}
::ng-deep .pa-file-list-menu .file-item .file-icon i {
  font-size: 20px;
  color: var(--secondary-subtle-inverse);
}
::ng-deep .pa-file-list-menu .file-item .file-name {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: var(--ion-text-color);
}
::ng-deep .pa-file-list-menu .file-item .file-name .p-menuitem-text {
  display: block;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  overflow-wrap: break-word;
  line-height: 1.4;
}
/*# sourceMappingURL=pa-file-list.component.css.map */
